import React from 'react';
import CircadiaPieChart from '../../../../components/GraphBox/Components/CircadiaPieChart.tsx';
import { useGetAssetCountByCategoryQuery } from '../../../../api/asset.api.ts';
import { useSelector } from 'react-redux';
import { selectActiveFilters } from '../../../../redux/slices/filterSlice';
import { selectAccount } from '../../../../redux/slices/accountSlice';
import { ASSETS_BY_CATEGORY } from '../../../../constants/messages.tsx';

interface AssetCategoryChartProps {
	registerExportFn?: (exportFn: () => void) => void;
	fullWidth?: boolean;
}

const AssetCategoryChart: React.FC<AssetCategoryChartProps> = ({
	registerExportFn,
	fullWidth = false,
}) => {
	const activeFilters = useSelector(selectActiveFilters);
	const account = useSelector(selectAccount);
	const accountId = account?.accountId ?? 0;
	const sourceId = account?.sourceId ?? 0;
	const accountTypeCode = account?.accountTypeCode ?? '';

	const { data: assetCountByCategory = [] } = useGetAssetCountByCategoryQuery(
		{ sourceId, accountId, accountTypeCode, filters: activeFilters },
		{ skip: !accountId }
	);

	return (
		<CircadiaPieChart
			data={assetCountByCategory}
			title={ASSETS_BY_CATEGORY}
			registerExportFn={registerExportFn}
			fullWidth={fullWidth}
		/>
	);
};

export default AssetCategoryChart;
